import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem("tt_token"));
  const [email, setEmail] = useState(localStorage.getItem("tt_email"));

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    localStorage.setItem("tt_token", res.data.token);
    localStorage.setItem("tt_email", res.data.email);
    setToken(res.data.token);
    setEmail(res.data.email);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem("tt_token");
    localStorage.removeItem("tt_email");
    setToken(null);
    setEmail(null);
  };

  useEffect(() => {
    if (token) {
      api.get("/auth/me").catch(() => logout());
    }
    // eslint-disable-next-line
  }, []);

  return (
    <AuthContext.Provider value={{ token, email, login, logout, isAuthed: !!token }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
